import { ActionIcon, Text } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import { useElementHeightCssVar } from '@/hooks/useElementHeightCssVar';

import s from './MobileBottomNav.module.scss';

export type MobileBottomNavItem = {
  key: string;
  label: string;
  icon: React.ReactNode;
};

type MobileBottomNavProps = {
  items: MobileBottomNavItem[];
  activeKey: string | null;
  onChange: (key: string) => void;
  className?: string;
};

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ items, activeKey, onChange, className }) => {
  const rootRef = React.useRef<HTMLElement | null>(null);

  useElementHeightCssVar({ ref: rootRef, cssVarName: '--mobile-bottom-nav-height' });

  return (
    <nav ref={rootRef} className={cn(s.root, className)}>
      <div className={s.root__inner}>
        {items.map((item) => {
          const isActive = item.key === activeKey;

          return (
            <BaseClickable
              key={item.key}
              withHover
              className={cn(s.root__item, isActive && s.root__item_active)}
              onClickWithValue={onChange}
              value={item.key}
              ariaLabel={item.label}
            >
              <ActionIcon size="md" c={isActive ? undefined : 'gray'} variant="transparent" className={s.root__icon}>
                {item.icon}
              </ActionIcon>
              <Text
                size="xs"
                variant={isActive ? 'gradient' : 'text'}
                gradient={{ from: '#56AFFC', to: '#465CFF', deg: 107.33 }}
                fw={600}
                className={s.root__label}
              >
                {item.label}
              </Text>
            </BaseClickable>
          );
        })}
      </div>
    </nav>
  );
};

export default React.memo(MobileBottomNav);
